import { UserRecordType } from "pages/SharedRecords.types";
import { Identifier } from "react-admin";

export type ProfileType = {
  id: Identifier;
  fullName: string;
  hasMoodleAuth: boolean;
  avatar?: string;
  moodleUserId?: number;
  language: string;
};

export function getProfile() {
  const profile = localStorage.getItem("profile");
  if (profile) {
    return JSON.parse(profile) as ProfileType;
  } else {
    return null;
  }
}

export function profileFromUser(user: UserRecordType): ProfileType {
  const { id, first_name, last_name, moodle_user, language } = user;
  const fullName = `${first_name} ${last_name}`;
  const hasMoodleAuth = moodle_user ? moodle_user.has_auth_token : false;
  const moodleUserId = moodle_user ? moodle_user.id : undefined;

  return { id, fullName, hasMoodleAuth, moodleUserId, language };
}
